import { render, staticRenderFns } from "./DespachosAceiteBodegas.vue?vue&type=template&id=bd24d4ce&scoped=true&"
import script from "./DespachosAceiteBodegas.vue?vue&type=script&lang=js&"
export * from "./DespachosAceiteBodegas.vue?vue&type=script&lang=js&"
import style0 from "./DespachosAceiteBodegas.vue?vue&type=style&index=0&id=bd24d4ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd24d4ce",
  null
  
)

export default component.exports